export const c_description_list_m_auto_fit_GridTemplateColumns_minmax_min = {
  "name": "--pf-c-description-list--m-auto-fit--GridTemplateColumns--minmax--min",
  "value": "15.625rem",
  "var": "var(--pf-c-description-list--m-auto-fit--GridTemplateColumns--minmax--min)"
};
export default c_description_list_m_auto_fit_GridTemplateColumns_minmax_min;